/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserProfileDto } from '../../models/update-user-profile-dto';
import { UserDto } from '../../models/user-dto';

export interface UsersControllerUpdateProfile$Params {

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
      body: UpdateUserProfileDto
}

export function usersControllerUpdateProfile(http: HttpClient, rootUrl: string, params: UsersControllerUpdateProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
  const rb = new RequestBuilder(rootUrl, usersControllerUpdateProfile.PATH, 'patch');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDto>;
    })
  );
}

usersControllerUpdateProfile.PATH = '/api/v1/users/me';
